import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Box, Paper, Grid, MenuItem } from '@mui/material';
import logo from '../assets/logo.jpg';
import '../index.css';

const PatientUpdate = ({ patient }) => {
    // Simulando datos de un paciente para la demostración
    const [patientData, setPatientData] = useState({
        name: 'Juan Pérez',
        dob: '1980-01-01',
        sex: 'Masculino',
        maritalStatus: 'Casado',
        idNumber: '123456789',
        insurer: 'Seguro Nacional',
        email: 'juan.perez@example.com',
        address: 'Calle Falsa 123',
        phone: '+123456789',
        otherData: 'N/A',
        nextAppointment: '2024-12-19T10:00'
    });

    const [age, setAge] = useState('');
    const [emailError, setEmailError] = useState(false);

    useEffect(() => {
        if (patientData.dob) {
            const calculateAge = () => {
                const birthDate = new Date(patientData.dob);
                const today = new Date();
                const ageInMilliseconds = today - birthDate;
                const ageDate = new Date(ageInMilliseconds);
                const years = ageDate.getUTCFullYear() - 1970;
                const months = ageDate.getUTCMonth();
                const days = ageDate.getUTCDate() - 1;

                if (years >= 1) {
                    setAge(`${years} años`);
                } else {
                    setAge(`${months} meses ${days} días`);
                }
            };

            calculateAge();
        }
    }, [patientData.dob]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPatientData({ ...patientData, [name]: value });

        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            setEmailError(!emailRegex.test(value));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Actualizar Paciente', patientData);
    };

    return (
        <Box className="fixed-container">
            <Paper elevation={3} sx={{ padding: 4, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img src={logo} alt="Logo del Consultorio" style={{ width: 100, marginBottom: 20 }} />
                    <Typography component="h1" variant="h5">Actualizar Paciente</Typography>
                    <form onSubmit={handleSubmit} style={{ width: '100%', marginTop: 1 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="name"
                                    label="Nombre"
                                    name="name"
                                    autoComplete="name"
                                    value={patientData.name}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    type="date"
                                    id="dob"
                                    label="Fecha de Nacimiento"
                                    name="dob"
                                    autoComplete="dob"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={patientData.dob}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="age"
                                    label="Edad"
                                    name="age"
                                    value={age}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    select
                                    id="sex"
                                    label="Sexo"
                                    name="sex"
                                    value={patientData.sex}
                                    onChange={handleInputChange}
                                >
                                    <MenuItem value="Masculino">Masculino</MenuItem>
                                    <MenuItem value="Femenino">Femenino</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    select
                                    id="maritalStatus"
                                    label="Estado Civil"
                                    name="maritalStatus"
                                    value={patientData.maritalStatus}
                                    onChange={handleInputChange}
                                >
                                    <MenuItem value="Soltero">Soltero</MenuItem>
                                    <MenuItem value="Casado">Casado</MenuItem>
                                    <MenuItem value="Divorciado">Divorciado</MenuItem>
                                    <MenuItem value="Union libre">Union libre</MenuItem>
                                    <MenuItem value="Viudo">Viudo</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="idNumber"
                                    label="Número de ID"
                                    name="idNumber"
                                    value={patientData.idNumber}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="insurer"
                                    label="Aseguradora"
                                    name="insurer"
                                    value={patientData.insurer}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="email"
                                    label="Correo Electrónico"
                                    name="email"
                                    value={patientData.email}
                                    onChange={handleInputChange}
                                    error={emailError}
                                    helperText={emailError ? 'Formato de correo electrónico no válido' : ''}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="address"
                                    label="Domicilio"
                                    name="address"
                                    value={patientData.address}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="phone"
                                    label="Teléfono"
                                    name="phone"
                                    value={patientData.phone}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="nextAppointment"
                                    label="Próxima Cita"
                                    type="datetime-local"
                                    name="nextAppointment"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={patientData.nextAppointment}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="otherData"
                                    label="Otros Datos"
                                    name="otherData"
                                    multiline
                                    rows={4}
                                    value={patientData.otherData}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ marginTop: 3, marginBottom: 2 }}
                        >
                            Actualizar
                        </Button>
                    </form>
                </Box>
            </Paper>
        </Box>
    );
};

export default PatientUpdate;
